import { eventBus } from '@/main'

let loader = null
let fields = null
const doms_ids = [
  199, // Guadeloupe
  213, // Martinique
  202, // Guyane
  228, // Réunion
  214, // Mayotte
  236, // Saint-Pierre-et-Miquelon
  231, // Saint-Barthélemy
  234, // Saint-Martin
  252, // Wallis et Futuna
  227, // Polynésie française
  221, // Nouvelle-Calédonie
  246, // Terres australes françaises
]

export const fieldsCountrySelect = fields => {
  if (!fields || !fields.country) return []
	
  const doms = []
  let fr = null
  const others = []

  for (const country of fields.country) {
    if (country.id === 6/* fr id */) {
      fr = { ...country }
      fr.text += ' métropolitaine'
    } else if (doms_ids.includes(country.id)) {
      doms.push(country)
    } else {
      others.push(country)
    }
  }
  others.unshift(fr, {
    text: 'France d\'outre-mer',
    children: doms,
  })
  return others
}

export const optionFields = {
  data: () => ({
    fields: false,
  }),
  methods: {
    getAllFields() {
      if (!loader) {
        loader = this.$http.get('/api/options/').then(
          res => fields = res.data,
          err => console.error('Failed to load options', err),
        )
      }

      loader.then(() => {
        this.fields = fields
        eventBus.$emit('optionFields', fields)
      })
    },
    getFieldItems(fieldname, isSelect = 0, altfieldfname = '', aucun = '') {
      eventBus.$on('optionFields', (data) => {
        if (aucun != '') {
          data[fieldname].unshift({ id: 0, text: aucun })
        }

        if (altfieldfname != '') {
          eventBus.$emit('fieldItem', [altfieldfname, data[fieldname], isSelect])
        } else {
          eventBus.$emit('fieldItem', [fieldname, data[fieldname], isSelect])
        }
      })
    },
    getFieldName(fieldId, fieldname) {
      if (this.fields && this.fields[fieldname]) {
        for (const value of this.fields[fieldname]) {
          if (value.id == fieldId) {
            // Special case for DOM TOM countries
            if (fieldname === 'country' && doms_ids.includes(value.id)) {
              return 'France'
            }

            return value.text
          }
        }
      }
      return ''
    },
  },
  computed: {
    fieldsCountrySelect() {
      return fieldsCountrySelect(this.fields)
    },
  },
  created() {
    this.getAllFields()
  },
}
